/* unplugin-vue-components disabled */import { render } from "./orderAppeal.vue?vue&type=template&id=dec1442a&scoped=true"
import script from "./orderAppeal.vue?vue&type=script&lang=js"
export * from "./orderAppeal.vue?vue&type=script&lang=js"

import "./orderAppeal.vue?vue&type=style&index=0&id=dec1442a&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dec1442a"]])

export default __exports__